import React from "react";
import { PILLAR_ORDER, PILLARS } from "../../lib/inventorySkills";

const LABEL_COLOR = { Strong: "#4ade80", Moderate: "#facc15", Weak: "#f87171" };
const RATING_DOT = { anchor: "#4ade80", good: "#60a5fa", limiter: "#f87171" };

// Ring + % + label: how well the assessment ratings match this archetype's key skills.
export function FitRing({ fit, size = 56, testid }) {
  if (!fit) return null;
  const color = LABEL_COLOR[fit.label] || "#a0a0a0";
  const r = (size - 6) / 2, c = 2 * Math.PI * r, dash = c * (fit.fit / 100);
  return (
    <div className="flex flex-col items-center shrink-0" data-testid={testid} title={fit.reason}>
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="-rotate-90">
          <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="4" />
          <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth="4" strokeLinecap="round" strokeDasharray={`${dash} ${c - dash}`} style={{ transition: "stroke-dasharray 0.6s ease" }} />
        </svg>
        <div className="absolute inset-0 flex items-center justify-center text-sm font-bold tabular-nums text-white">{fit.fit}%</div>
      </div>
      <div className="text-[8px] uppercase tracking-[0.3em] font-bold mt-1" style={{ color }}>{fit.label}</div>
    </div>
  );
}

// Key skills grouped by pillar with rating dots — the "why" behind the fit %.
export function FitBreakdown({ fit, testid }) {
  if (!fit?.keySkills?.length) return null;
  return (
    <div className="mt-3 pt-3 border-t border-white/10" data-testid={testid}>
      <div className="text-[9px] uppercase tracking-[0.35em] text-[#757575] mb-1.5">Assessment match · key skills</div>
      <div className="flex flex-wrap gap-x-4 gap-y-1.5">
        {PILLAR_ORDER.map(p => {
          const items = fit.keySkills.filter(k => k.pillar === p); if (!items.length) return null;
          return (
            <div key={p} className="flex items-center gap-1.5 flex-wrap">
              <span className="text-[9px] uppercase tracking-[0.25em] text-[#575757]">{PILLARS[p].title.split(" ")[0]}</span>
              {items.map(k => (
                <span key={k.skillId} className="inline-flex items-center gap-1 text-[11px] text-[#c0c0c0]" title={`${k.name}: ${k.rating ? k.rating.replace("limiter", "rate limiter") : "not yet rated"}${k.isPrimary ? " · top 3 anchor" : ""}`} data-testid={`fit-skill-${k.skillId}`}>
                  <span className="w-2 h-2 rounded-full inline-block" style={{ background: RATING_DOT[k.rating] || "transparent", border: k.rating ? "none" : "1px solid #575757" }} />{k.name}{k.isPrimary && <span className="text-[var(--org-accent)]">★</span>}
                </span>
              ))}
            </div>
          );
        })}
      </div>
    </div>
  );
}
